// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from 'react'

import { IconButton as MuiIconButton, IconButtonProps as DefaultIconButtonProps, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'

import { IconName } from '../icon/components/custom-icons'
import Icon from '../icon'

interface IconButtonProps extends DefaultIconButtonProps {
    icon?: IconName
    tooltip?: string
    variant?: 'outlined' | 'contained' | 'default'
}

const DefaultIconButton = styled(MuiIconButton)`
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    background-color: ${({ theme }) => theme.palette.background.default};
`

const OutlinedIconButton = styled(DefaultIconButton)`
    border: 1px solid ${({ theme, color }) => theme.palette[color]?.dark || theme.palette.grey[800]};
    &:hover {
        border-color: ${({ theme, color }) => theme.palette[color]?.main || theme.palette.grey[100]};
    }
`

const IconButton = (props: IconButtonProps) => {
    const { variant = 'default' } = props

    const IconButtonComponent = variant === 'outlined' ? OutlinedIconButton : DefaultIconButton

    const IconContent = (Variant: React.ElementType) => (
        <Variant {...props}>{props.icon ? <Icon name={props.icon} /> : props.children}</Variant>
    )

    return props.tooltip ? (
        <Tooltip arrow title={props.tooltip}>
            <span>{IconContent(IconButtonComponent)}</span>
        </Tooltip>
    ) : (
        IconContent(IconButtonComponent)
    )
}

export default IconButton
